import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { RmaBaseUrlPipe } from '@rma/dashboard/generic/util/environment';
import { NavigationService } from '@rma/dashboard/generic/util/navigation';
import { RmaIconComponent } from '@rma/generic/ui/icon';
import { map, Observable } from 'rxjs';
import { SearchFacade } from '../domain/search.facade';
import { DashboardSearchResult, SearchResultGroup } from '../domain/search-results.model';
import { SearchNoResultsComponent } from '../ui-search-no-results/search-no-results.component';
@Component({
  selector: 'rma-search-modal',
  imports: [
    AsyncPipe,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    RmaIconComponent,
    SearchNoResultsComponent,
    TranslocoModule,
  ],
  providers: [provideTranslocoScope('dashboardSearch'), RmaBaseUrlPipe],
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchModalComponent {
  protected readonly filteredOptions$: Observable<SearchResultGroup[]>;
  protected readonly showCancelIcon$: Observable<boolean>;
  protected readonly searchControl = new FormControl('');

  public constructor(
    private readonly baseUrl: RmaBaseUrlPipe,
    private readonly modalRef: MatDialogRef<SearchModalComponent>,
    private readonly navigationService: NavigationService,
    private readonly searchFacade: SearchFacade,
  ) {
    this.showCancelIcon$ = this.searchControl.valueChanges.pipe(map((value) => Boolean(value)));
    this.filteredOptions$ = this.searchFacade.initialiseSearchResults(this.searchControl.valueChanges);
  }

  public onClearIconClicked(): void {
    this.searchControl.setValue('');
  }

  public onResultClick(item: DashboardSearchResult): void {
    this.searchControl.setValue('');
    if (item.OtherSite) {
      window.open(this.baseUrl.transform(`${item.OtherSite.toLowerCase()}${item.Url}`), '_blank');
    } else {
      this.navigationService.navigateTo(item.Url);
      this.modalRef.close();
    }
  }
}
